import s12nMembershipFields from 'bundles/accomplishments/promises/s12nMembershipFields';
import s12nMembershipsPromise from 'bundles/catalogP/promises/s12nMemberships';

export default function (code: $TSFixMe) {
  const query = Object.assign({}, s12nMembershipFields, {
    q: 'byCode',
    code,
  });

  query.includes.signatureTrackProfile = {
    fields: ['firstName', 'middleName', 'lastName'],
  };

  return s12nMembershipsPromise(query).then(function (s12nMemberships: $TSFixMe) {
    return s12nMemberships.first();
  });
}
